import { render, staticRenderFns } from "./tb.vue?vue&type=template&id=f5ba63ec&scoped=true"
import script from "./tb.vue?vue&type=script&lang=js"
export * from "./tb.vue?vue&type=script&lang=js"
import style0 from "./tb.vue?vue&type=style&index=0&id=f5ba63ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ba63ec",
  null
  
)

export default component.exports